"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECTION_KEY = void 0;
var tslib_1 = require("tslib");
/* eslint-disable no-console */
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var types_1 = require("../../types");
var Authenticated_1 = require("./Authenticated");
var UnAuthenticated_1 = require("./UnAuthenticated");
var myaccount_frontend_shared_1 = require("@alinta-digital/myaccount-frontend-shared");
exports.SECTION_KEY = 'paymentDetails';
var PaymentDetails = function (props) {
    var _a;
    (0, myaccount_frontend_shared_1.useAnalyticsLoadV2)(props.ga, 'load.1.paymentdetailscapture', ((_a = props.ga) === null || _a === void 0 ? void 0 : _a.eventName) === 'process.payment');
    var onCancel = props.onCancel, onSubmit = props.onSubmit, baseURL = props.baseURL, skipMountingScript = props.skipMountingScript, environment = props.environment, guid = props.guid, accountDetails = props.accountDetails, isUnAuthenticated = props.isUnAuthenticated, processStartDateTime = props.processStartDateTime, savedPayment = props.savedPayment;
    var currentStepKey = 'step1';
    var nextStepKey = 'step2';
    var appBaseUrl = baseURL ? baseURL : 'https://www.alintaenergy.com.au';
    var apacBamboraTestUrl = environment === types_1.Environment.Production
        ? 'https://customcheckout.bambora.com.au/2.0.0/customcheckout.js'
        : 'https://customcheckout-uat.bambora.net.au/2.0.0/customcheckout.js';
    var submit = function (result, cardType) {
        var _a, _b;
        onSubmit(result, cardType);
        if (((_a = props.ga) === null || _a === void 0 ? void 0 : _a.eventName) === 'process.payment') {
            (_b = props.ga) === null || _b === void 0 ? void 0 : _b.push('click.5.confirm');
        }
    };
    var cancel = function () {
        var _a, _b;
        onCancel();
        if (((_a = props.ga) === null || _a === void 0 ? void 0 : _a.eventName) === 'process.payment') {
            (_b = props.ga) === null || _b === void 0 ? void 0 : _b.push('click.5.cancel');
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, isUnAuthenticated ? (react_1.default.createElement(UnAuthenticated_1.UnAuthenticated, { baseURL: appBaseUrl, bamboraURL: apacBamboraTestUrl, guid: guid, skipMountingScript: skipMountingScript || false, currentStepKey: currentStepKey, nextStepKey: nextStepKey, onCancel: cancel, onSubmit: submit, ga: props.ga })) : (react_1.default.createElement(Authenticated_1.Authenticated, { baseURL: appBaseUrl, bamboraURL: apacBamboraTestUrl, guid: guid, ga: props.ga, skipMountingScript: skipMountingScript || false, currentStepKey: currentStepKey, nextStepKey: nextStepKey, onCancel: cancel, onSubmit: submit, processStartDateTime: processStartDateTime, accountDetails: accountDetails, savedPayment: savedPayment }))));
};
exports.default = PaymentDetails;
//# sourceMappingURL=PaymentDetails.js.map